import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo } from "@/components/Logo";
import { ArrowLeft, ArrowRight } from "lucide-react";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("rrr_admin_token")) {
      nav("/admin");
    }
  }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("rrr_admin_token", data.token);
      toast.success("Welcome back.");
      nav("/admin");
    } catch {
      toast.error("Invalid credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8F9FA] flex flex-col">
      <header className="p-6 lg:p-8 flex items-center justify-between">
        <Link to="/" data-testid="admin-login-home-link">
          <Logo size="md" />
        </Link>
        <Link
          to="/"
          className="font-mono-label text-[#495057] hover:text-[#0B1215] flex items-center gap-2"
          data-testid="admin-login-back-link"
        >
          <ArrowLeft size={14} /> Back to site
        </Link>
      </header>

      <main className="flex-1 flex items-center justify-center px-6">
        <div className="w-full max-w-md">
          <div className="font-mono-label text-[#FF5A36] mb-4">· ADMIN / SIGN IN</div>
          <h1 className="font-display text-4xl sm:text-5xl tracking-tighter leading-[0.95]">
            Welcome back.
          </h1>
          <p className="text-[#495057] mt-4">Sign in to manage quote requests, gallery and reviews.</p>

          <form
            onSubmit={submit}
            className="mt-10 border-2 border-[#0B1215] bg-[#F8F9FA] p-8 space-y-5"
            data-testid="admin-login-form"
          >
            <div>
              <Label className="font-mono-label">Email</Label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-2 rounded-none border-[#0B1215] h-12"
                placeholder="admin@thepropertycuratorwarwickshire.co.uk"
                data-testid="admin-login-email"
                required
              />
            </div>
            <div>
              <Label className="font-mono-label">Password</Label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-2 rounded-none border-[#0B1215] h-12"
                placeholder="••••••••"
                data-testid="admin-login-password"
                required
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full inline-flex items-center justify-center gap-2 bg-[#0B1215] hover:bg-[#FF5A36] disabled:opacity-60 text-[#F8F9FA] px-8 py-4 font-mono-label active:scale-95 transition-all"
              data-testid="admin-login-submit"
            >
              {loading ? "Signing in..." : "Sign in"} <ArrowRight size={16} />
            </button>
          </form>
        </div>
      </main>
    </div>
  );
}
